export default "__VITE_ASSET__DIfn5usG__"